import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '@/components/atoms/Text/Text';
import Section from '@/components/molecules/Section/Section';

const LegalContent: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <Text variant="title" className="mb-2">{t('termsAndPrivacyModal.legal.title')}</Text>
        <Text variant="caption">{t('termsAndPrivacyModal.legal.effectiveDate')}</Text>
      </div>
  
      <div className="space-y-4">
        <Section number="1" title={t('termsAndPrivacyModal.legal.sections.corporateStructure.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.legal.sections.corporateStructure.content')}
        </Section>
        
        <Section number="2" title={t('termsAndPrivacyModal.legal.sections.licensing.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.legal.sections.licensing.content')}
        </Section>
        
        <Section number="3" title={t('termsAndPrivacyModal.legal.sections.prohibited.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.legal.sections.prohibited.content')}
        </Section>
        
        <Section number="4" title={t('termsAndPrivacyModal.legal.sections.dataSecurity.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.legal.sections.dataSecurity.content')}
        </Section>
        
        <Section number="5" title={t('termsAndPrivacyModal.legal.sections.jurisdiction.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.legal.sections.jurisdiction.content')}
        </Section>
        
        <Section number="6" title={t('termsAndPrivacyModal.legal.sections.contact.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.legal.sections.contact.content')}
        </Section>
      </div>
    </div>
  );
};

export default LegalContent;